import { MessageContentFeedback } from '../types';

/*
 * Copyright (C) iSchoolConnect - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export const mainMenuQuickReply = [
	{
		name: 'Main Menu',
	},
];
export const exitQuickReply = [
	{
		name: 'Exit',
	},
];

export const feedbackMessageComponentContent: Omit<MessageContentFeedback, 'message_id'> = {
	title: 'How would you rate our chat experience?',
	thankYouText: 'Thank you for the feedback! 😊',
	options: [
		{
			icon: 'ThumbUpAltOutlined',
			text: 'Good',
			value: 'positive',
		},
		{
			icon: 'ThumbDownAltOutlined',
			text: 'Not good',
			value: 'negative',
		},
	],
};
